<script setup>
import { debounce, keyBy } from 'lodash-es';
import { useBiMapHelper } from '~/bi/components/widgets/map-widget/bi-map-helper.js';

const props = defineProps({
  activeIcon: {
    type: String,
    default: null,
  },
  type: {
    type: String,
    default: 'plain',
    validator(value) {
      return ['plain', 'outlined'].includes(value);
    },
  },
});

const emit = defineEmits(['iconSelected']);

const { AVAILABLE_ICONS } = useBiMapHelper();

const state = reactive({
  is_menu_open: false,
  current_icon: props.activeIcon || 'asset',
});

const icons = computed(() => {
  return AVAILABLE_ICONS.map((icon) => {
    return {
      key: icon.key,
      value: icon.name,
      path: icon.path,
    };
  });
});
const icons_map = computed(() => {
  return keyBy(icons.value, 'key');
});

function onSelectIcon(icon) {
  emit('iconSelected', icon);
}

watch(() => props.activeIcon, (new_icon) => {
  if (new_icon)
    state.current_icon = new_icon;
});

onMounted(async () => {
  if (props.activeIcon)
    state.current_icon = props.activeIcon;
});
</script>

<template>
  <HawkMenu
    position="fixed"
    additional_trigger_classes="p-0 m-0 !ring-0 !border-0 focus:!ring-0"
    @open="state.is_menu_open = true"
    @close="state.is_menu_open = false"
  >
    <template #trigger="{ open }">
      <slot name="trigger">
        <div v-if="props.type === 'plain'" class="w-3 h-3 rounded-full mt-[5px]" />
        <div v-else class="border rounded p-1.5 flex items-center gap-1">
          <img :src="icons_map[props.activeIcon].path" alt="icon" class="w-5 h-auto">
          <IconHawkChevronUp v-if="open" class="w-4 h-4" />
          <IconHawkChevronDown v-else class="w-4 h-4" />
        </div>
      </slot>
    </template>
    <template #content>
      <div class="w-[355px] p-3">
        <div class="flex flex-wrap gap-x-3 gap-y-2">
          <div
            v-for="icon in icons"
            :key="icon.key"
            class="p-0.5 cursor-pointer"
            :class="{
              '!border-gray-300': props.activeIcon === icon.key,
            }"
            @click="onSelectIcon(icon.key)"
          >
            <img :src="icon.path" alt="icon" class="w-5 h-auto">
          </div>
        </div>
      </div>
    </template>
  </HawkMenu>
</template>

<style lang="scss">
.vc-chrome-picker {
  box-shadow: none !important;
  .toggle-icon {
    margin-left: 12px;
  }
}
</style>
